import {
  Directive,
  Input,
} from '@angular/core';

@Directive({
  selector: '[maxLengthNumber]',
  host: {
    "(input)": 'onInputChange($event)',
    '(keypress)': '_onKeypress($event)',
  }
})
export class MaxLengthNumberDirective {
  
  @Input('maxLengthNumber') limit
  max: string
  constructor() {
    this.max = '9';
  }

  onInputChange(event) {
    const limit = +this.limit;
    if (event.target.value.length === limit + 1) event.target.value = this.max.repeat(limit);
  }
  _onKeypress(event) {
    const limit = +this.limit;
    if (event.target.value.length === limit) event.preventDefault();
  }

}